module.exports = __webpack_public_path__ + "media/images/static/top/local/photo4-f926a227cf18c257e1782c6889f2faf3.png";